export default {
    nameList: [
        // {
        //     entityField: "fileNumber",
        //     showField: "档案编号",
        //     fieldWeight: 150,
        //     fieldType: "string",
        // },
        {
            entityField: "bgmCode",
            showField: "商品编号",
            fieldWeight: 150,
            fieldType: "string",
        },
        {
            entityField: "bgmName",
            showField: "通用名称",
            fieldWeight: 200,
            fieldType: "string",
            isRift: 1,
            riftField: "bgmId"
        },
        
        {
            entityField: "spec",
            showField: "规格",
            fieldWeight: 150,
            fieldType: "string"
        },
        {
            entityField: "manufacturer",
            showField: "生产厂商",
            fieldWeight: 180,
            fieldType: "string"
        }, {
            entityField: "placeorigin",
            showField: "产地",
            fieldWeight: 60,
            fieldType: "string"
        }, {
            entityField: "bgpUnitmeasurement",
            showField: "包装单位",
            fieldWeight: 80,
            fieldType: "string"
        }, {
            entityField: "packingSpec",
            showField: "装箱规格",
            fieldWeight: 80,
            fieldType: "string"
        },
        
    ]
}
